module.exports = __webpack_public_path__ + "static/img/youtube.c67420d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/youtube.png
// module id = 39Gr
// module chunks = 0